import { render, staticRenderFns } from "./Dashboard115View.vue?vue&type=template&id=063bd0c1&scoped=true&"
import script from "./Dashboard115View.vue?vue&type=script&lang=js&"
export * from "./Dashboard115View.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard115View.vue?vue&type=style&index=0&id=063bd0c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063bd0c1",
  null
  
)

export default component.exports